module.exports = __webpack_public_path__ + "static/media/csrd_dashboard_img.aa322a9f.svg";